<template>
  <div class="card-update-page">
    <card title="Edit Page">
      <div>
        <fieldset :disabled="inProgress">

          <fieldset class="form-group">
            <label for="pageHeading">Page Type</label>
            <select v-model="page.type" class="form-control">
              <option value="place">Place</option>
              <option value="events">Events</option>
            </select>
          </fieldset>

          <fieldset class="form-group" :dir="dir">
            <label for="pageHeading">Label</label>
            <input
              id="pageHeading"
              type="text"
              class="form-control form-control-lg"
              v-model="page.heading[lang]"
              placeholder="Page Heading"
            />
          </fieldset>

          <fieldset class="form-group" >
            <label>Description</label>
            <ck-editor :dir="dir" :key="lang" :language="lang" v-model="page.description[lang]"></ck-editor>
          </fieldset>

          <fieldset class="form-group" >
            <label>QR Code URL</label>
            <input
              id="pageHeading"
              type="text"
              class="form-control form-control-lg"
              v-model="page.qrUrl"
              placeholder="https://domain.com/"
            />
          </fieldset>

          <fieldset class="form-group" >
            <label>QR Code Message</label>
            <input
              id="pageHeading"
              type="text"
              class="form-control form-control-lg"
              v-model="page.qrMessage"
              placeholder="A brief description of where the QR code will take the user."
            />
          </fieldset>

          <fieldset class="form-group">
            <label>Issuu Embed Label</label>
            <input
              type="text"
              class="form-control form-control-lg"
              v-model="page.issuuEmbedLabel"
              placeholder="Document, Guide, PDF, etc"
            />
          </fieldset>

          <fieldset class="form-group">
            <label>Issuu Embed Url</label>
            <input
              type="text"
              class="form-control form-control-lg"
              v-model="page.issuuEmbedUrl"
              placeholder="https://e.issuu.com/embed.html?d="
            />
          </fieldset>

          <fieldset class="form-group" v-if="['place', 'events'].indexOf(page.type) !== -1">
            <label>Select Minimap Image</label>
            <input-asset v-model="page.minimapImage" defaultCategory="minimapImage"></input-asset>
          </fieldset>

          <fieldset class="form-group" v-if="['place'].indexOf(page.type) !== -1">
            <label>Select Background Image</label>
            <input-asset v-model="page.backgroundImage" defaultCategory="pageBackground"></input-asset>
          </fieldset>

          <fieldset v-if="page.type === 'events'" class="form-group">
            <page-bg-content
              :bgContent="page.backgroundContent"
              :dir="dir"
              :lang="lang"
              @openAssetLibrary="openAssetLibrary"
              @updateBgContent="updateBgContent"
            ></page-bg-content>
          </fieldset>

          <fieldset v-if="page.type === 'events'" class="form-group">
            <page-slides
              :slides="page.slides"
              :dir="dir"
              :lang="lang"
              @openAssetLibrary="openAssetLibrary"
              @updateSlides="updateSlides"
            ></page-slides>
          </fieldset>

        </fieldset>
      </div>
    </card>
  </div>
</template>

<script>
import AssetPreviewBox from '@/components/AssetPreviewBox'
import PageBgContent from '@/pages/PageEdit/PageBgContent'
import PageSlides from '@/pages/PageEdit/PageSlides'
import CkEditor from '@/components/CKEditor'
import InputAsset from '@/components/InputAsset'
import InfoBox from '@/components/InfoBox'

export default {
  name: 'card-update-page',

  components: {
    AssetPreviewBox,
    CkEditor,
    PageBgContent,
    PageSlides,
    InputAsset,
    InfoBox
  },

  props: {
    page: Object,
    inProgress: Boolean,
    lang: String,
    dir: String
  },

  data () {
    return {
      minimapImage: null
    }
  },

  created () {
    this.$store.dispatch('FETCH_ASSETS')
  },

  methods: {
    bgContentSelected(event, item) {
      this.$emit('bgContentSelected', event, item)
    },

    openAssetLibrary(context, assetSelected) {
      this.$emit('openAssetLibrary', context, assetSelected)
    },

    updateBgContent(newBgContent) {
      this.page.backgroundContent = newBgContent
    },

    updateSlides(newSlides) {
      this.page.slides = newSlides
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
